import {memo, useCallback, useMemo, useState} from "react";
import {NavLink} from "react-router-dom";
import s from "./MobileNavItem.module.css";

const SHOW_DURATION = 0.6;

export const MobileNavItemHoc = memo(({
  children,
  className,
  to,
}) => {

  const [isShow, setIsShow] = useState(false);
  const [positionShow, setPositionShow] = useState({x: 0, y: 0});

  const onShow = useCallback((e) => {
    const targetCoords = e?.currentTarget?.getBoundingClientRect();
    const x = e?.clientX - targetCoords?.left;
    const y = e?.clientY - targetCoords?.top;
    setPositionShow({x, y});
    setIsShow(false);
    setTimeout(() => setIsShow(true), 0);
  }, [setPositionShow, setIsShow]);

  const eventClick = useCallback((e) => {
    onShow(e);
  }, [onShow])

  const styledShowBlock = useMemo(() => ({
    borderRadius: '50%',
    animationDuration: SHOW_DURATION + 's',
    background: '#e8973259',
    top: positionShow.y,
    left: positionShow.x,
  }), [positionShow]);

  return (
    <NavLink
      to={to}
      className={className ? className : null}
      onClick={eventClick}
    >
      <div
        className={`${s.showBlock} ${isShow && s.showBlockOn}`}
        style={styledShowBlock}
      />
      {children}
    </NavLink>
  );
});